module.exports = __webpack_public_path__ + "static/img/8.6f2c58f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/8.png
// module id = BP19
// module chunks = 0